import { Directive, Provider } from '@angular/core';
import { AppContextDirective } from '@modules/common/directives/app-context.directive';
import { SEARCH_SUGGESTION_OPENER } from '@modules/common/components/search-popup/search-suggestion-opener';
import { BaseAppStateService } from '@modules/common/services/base-app-state.service';
import { MailAppStateService } from '../services/mail-app-state.service';
import { MailRailFolderTrees } from '../services/mail-rail-folder-trees.service';
import { MailReaderOpenService } from '../services/mail-reader-open.service';
import { MailSuggestionOpener } from '../services/mail-suggestion-opener.service';

@Directive({
  selector: '[appMailAppContext]',
  standalone: true,
})
export class MailAppContextDirective extends AppContextDirective {
  static readonly providers = [
    ...BaseAppStateService.provideAs(MailAppStateService),
    // The one way into the reader: the list's clicks and the search popup's "Open email" (searchopen r2).
    MailReaderOpenService,
    // The rail's folder trees, so "Open folder" runs a tree's own open (searchopen r4).
    MailRailFolderTrees,
    // The rail's search popup draws its "Open email" button only because Mail provides this (searchopen r1).
    { provide: SEARCH_SUGGESTION_OPENER, useClass: MailSuggestionOpener },
  ];

  protected getProviders(): Provider[] {
    return MailAppContextDirective.providers;
  }
}
